import { SelectorConBuscador } from './SelectorConBuscador.jsx';
import { PERFIL_DE_CUENTA } from '../logica/perfilesDeSelector.js';

/*
 * REEXPORTACIÓN DEL CONTROL ÚNICO CON EL PERFIL DE CUENTA YA PUESTO.
 * (T-17-01 · RF-230, RF-233, RN-658, CA-17-01, CA-17-05)
 *
 * AQUÍ NO QUEDA NI UNA LÍNEA DE COMPORTAMIENTO. El selector con buscador —su
 * árbol, su teclado, su foco, sus tres estados, su filtrado en memoria— vive una
 * sola vez en `SelectorConBuscador.jsx`. Este archivo existe por una razón
 * concreta y acotada que RN-658 autoriza: sus cuatro consumidores de cuenta
 * (captura de gasto/ingreso/devolución, origen y destino del traspaso, filtro
 * «Cuenta o tarjeta» del historial) y las suites que los prueban hablan de
 * `cuentas` y de `ComboboxDeCuenta`, y no hacía falta tocarlos para generalizar el
 * control (CA-17-05: esas suites pasan sin cambiar una afirmación).
 *
 * LO ÚNICO QUE HACE es traducir el nombre del dato —`cuentas` → `opciones`— y
 * poner el perfil. Si alguien añade aquí estado, un `if`, un manejador de teclado
 * o un segundo árbol, está creando la segunda variante que RN-658 prohíbe: el
 * sitio donde se amplía el comportamiento es el control, una vez, para todos.
 */
export function ComboboxDeCuenta({
  cuentas,
  datoDePrueba = 'combobox-de-cuenta',
  ...resto
}) {
  return (
    <SelectorConBuscador
      perfil={PERFIL_DE_CUENTA}
      opciones={cuentas}
      datoDePrueba={datoDePrueba}
      {...resto}
    />
  );
}

export default ComboboxDeCuenta;
